module.exports = __webpack_public_path__ + "static/index/img/baikal-502.e3a1d320.jpg";